
export default function SectionHeader(props: { title: string }) {

    return (
        <div className="row">
            <p className="sectionTitle-pr"><span>{props.title}</span></p>
        </div>
    )
}